/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanySettingsService {

    /**
     * Get Company Settings
     * Get company settings based on your account.
     * @param xAccessToken
     * @returns any OK
     * @throws ApiError
     */
    public static getInternalApiFountainCompanySettings(
        xAccessToken: string,
    ): CancelablePromise<{
        /**
         * recruiter ui base url
         */
        recruiter_ui_url: string;
        /**
         * account slug
         */
        account_slug: string;
        /**
         * career site url
         */
        career_site: string;
        /**
         * hire account external id
         */
        hire_account_external_id: string;
        /**
         * Pusher app key
         */
        pusher_key: string;
        /**
         * Pusher cluster
         */
        pusher_cluster: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/fountain/company_settings',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Update Company Settings
     * Update company settings for your account.
     * @param xAccessToken
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putInternalApiFountainCompanySettings(
        xAccessToken: string,
        requestBody: {
            /**
             * Wx external ID
             */
            wx_external_id?: string;
        },
    ): CancelablePromise<{
        /**
         * Whether the update was successful
         */
        success: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal_api/fountain/company_settings',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                422: `Unprocessable Entity`,
            },
        });
    }

    /**
     * Indeed integration type
     * Indeed integration type based on your account.
     * @param xAccessToken
     * @returns any OK
     * @throws ApiError
     */
    public static getInternalApiFountainCompanySettingsIndeedIntegrationType(
        xAccessToken: string,
    ): CancelablePromise<{
        /**
         * LD flag for location level indeed enabled
         */
        location_based_indeed_enabled: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/fountain/company_settings/indeed_integration_type',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }

}